import contractedRnDServicesCapability from '../Rsp/contractedRnDServicesCapability';
import { applicantDetails } from '../Rsp/applicantDetails';
import { PageVisibilityFunctions } from '../types';
import declarationsAndAcknowledgement from '../Rsp/declarationsAndAcknowledgement';
import scheduleOfResearchFields from '../Rsp/scheduleOfResearchFields';

export const RspVariation: PageVisibilityFunctions = {
    applicantDetails,
    contractedRnDServicesCapability,
    scheduleOfResearchFields,
    declarationsAndAcknowledgement,
};
